import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

const safeDecode = (value: string): string => {
    try {
        return decodeURIComponent(value);
    } catch {
        return value;
    }
};

export const useQueryParams = (): Record<string, string> => {
    const { search } = useLocation();

    return useMemo(() => {
        const searchParams = new URLSearchParams(search);
        const params: Record<string, string> = {};

        searchParams.forEach((value, key) => {
            params[key] = safeDecode(value);
        });

        return params;
    }, [search]);
};